<template>
  <div class="ugc-container">
    <div
      class="tab-container"
      ref="tab"
      :style="{ top: appTopBarHeight + 'px' }"
    >
      <div class="tab-title">会员动态</div>
      <div class="tab-list">
        <div
          class="tab-item"
          :class="{ 'tab-item-active': curTab == index }"
          v-for="(item, index) in tabList"
          :key="index"
          @click="bindClickTab(item, index)"
          >{{ item.title }}</div
        >
      </div>
    </div>
    <div class="ugc-list-wrapper">
      <div
        class="ugc-scroll"
        :style="{ minHeight: minTabContainerHeight + 'px' }"
        v-for="(item, index) in tabList"
        :key="index"
        v-show="curTab == index"
      >
        <van-list
          v-if="item.init"
          v-model="item.loading"
          :finished="item.finished"
          :finished-text="isApp ? '没有更多了' : ''"
          @load="getUgcData(item)"
        >
          <div class="ugc-list">
            <UgcItem
              v-for="(item1, index1) in item.list"
              :key="index1"
              :data="item1"
              @focus="bindFocus"
              @like="bindLike"
              :userInfo="user"
              @user="bindUserInfo"
              @item="bindClickUgcItem"
              @likeList="bindClickLikeList"
              @mask="bindClickMask"
            />
          </div>
          <div style="overflow: hidden">
            <div
              class="empty-container"
              v-if="item.list && item.list.length == 0"
            >
              <img
                class="empty-image"
                src="https://btw-common-data.betterwestar.com/btw-admin/resource/c6909e87377d090f266d8b1e7f1852c5_wh=642_339.png"
                alt=""
              />
            </div>
            <div class="jump-app-btn-container" v-if="!isApp && item.finished">
              <div class="jump-app-btn" @click="bindJumpApp"
                >前往betterWE星球App查看更多动态</div
              >
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <van-popup
      v-model="showLikeList"
      position="bottom"
      :style="{ height: '80%' }"
    >
      <LikeList
        v-if="showLikeList"
        :id="likeListUgcId"
        @close="showLikeList = false"
      />
    </van-popup>
    <van-popup
      v-model="showLikeAnimate"
      :overlay="false"
      :lazy-render="false"
      class="like-pop"
    >
      <img
        class="like-image-animate"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2026-01/b6e961fc6044a8b73550478fa6b5f731_wh=360_360.png"
        alt=""
      />
    </van-popup>
  </div>
</template>

<script>
import UgcItem from './ugc-item.vue'
import LikeList from './like-list.vue'
export default {
  components: { UgcItem, LikeList },
  props: {
    shopId: {
      type: [Number, String],
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabList: [
        {
          title: '最新',
          type: 1,
          init: false,
          list: null,
          loading: false,
          finished: false,
          scrollTop: 0,
          page: 1
        },
        {
          title: '最热',
          type: 3,
          init: false,
          list: null,
          loading: false,
          finished: false,
          scrollTop: 0,
          page: 1
        }
      ],
      curTab: 0,
      isApp: false,
      appTopBarHeight: 0,
      likeListUgcId: 0,
      showLikeList: false,
      showLikeAnimate: false,
      minTabContainerHeight: 0
    }
  },
  computed: {
    user() {
      return (
        (this.$store.state.userInfo && this.$store.state.userInfo.user) || null
      )
    }
  },
  created() {
    this.init()
  },
  mounted() {
    setTimeout(() => {
      this.initTabScroll()
    }, 400)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async init() {
      this.isApp = this.$betterwe.isApp()
      this.appToken = await this.$betterwe.getAppToken()
      this.tabList[0].init = true
      this.getAppTopBarHeight()
      window.addEventListener('scroll', this.handleScroll)
    },
    async getAppTopBarHeight() {
      let res = await this.$betterwe.getAppTopBarHeight()
      this.appTopBarHeight = res || 68
      let tabBarHeight = (window.screen.height * 41) / 812 //tab栏实际高度
      let bottomHeight = (window.screen.height * 72) / 812 //底部距离底部的距离
      this.minTabContainerHeight =
        window.screen.height -
        this.appTopBarHeight -
        tabBarHeight -
        bottomHeight
    },
    bindClickMask() {
      location.href = ''
    },
    bindClickTab(item, index) {
      this.curTab = index
      if (!item.init) {
        item.needScroll = true
      } else {
        this.$nextTick(() => {
          const targetScrollTop = item.scrollTop
          window.scrollTo(0, targetScrollTop)
        })
      }
      item.init = true
    },
    //关注
    async bindFocus(data) {
      if (!this.isApp) {
        return
      }
      /* 列表关注后不允许取消关注 */
      if (data.base.user.is_follow) {
        this.bindUserInfo(data)
        return
      }
      let isFollow = data.base.user.is_follow ? 0 : 1
      let res = await this.$http
        .postBaseApp('member/appCamp/optionFollow', {
          unify_id: data.base.user.unify_id,
          flag: isFollow,
          token: this.appToken
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          data.base.user.is_follow = isFollow
          this.updateUgcFocus(data.base.user.unify_id, isFollow)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    //点赞
    async bindLike(data) {
      if (!this.isApp) {
        return
      }
      let isLike = data.base.like_info.is_like ? 0 : 1
      let res = await this.$http
        .postBaseApp('member/AppCamp/optionLove', {
          tid: data.detail.id,
          flag: isLike,
          tab_type: data.detail.tab_type,
          be_liked_unify_id: data.base.user.unify_id,
          token: this.appToken
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          data.base.like_info.is_like = isLike
          let num = data.base.like_info.number
          num = isLike ? num + 1 : num - 1
          data.base.like_info.number = num < 0 ? 0 : num
          if (isLike) {
            this.playLikeAnimate()
          }
          this.updateUgcLove(data, isLike)
        } else {
          this.$toast(res.msg)
        }
      }
      this.$http.get('member/index?a=shareLogPush', {
        from: '门店详情会员动态点赞点击',
        from_id: 250901
      })
    },
    //跳转用户信息
    bindUserInfo(data) {
      if (!this.isApp) {
        return
      }
      let id = data.base.user.unify_id
      this.$betterwe.jumpRoute(`/userDetailsPage?id=${id}`)
    },
    async getUgcData(item) {
      let curTab = this.curTab
      let url = this.isApp
        ? 'api/v1/GymCircle/getShopUgc'
        : 'api/v1/GymCircle/getTenShopUgc'
      let res
      if (this.isApp) {
        res = await this.$http
          .getBaseApp(url, {
            shop_id: this.shopId,
            page: item.page,
            page_size: 10,
            type: item.type,
            token: this.appToken
          })
          .catch(() => {})
      } else {
        res = await this.$http
          .getBaseApp(url, { shop_id: this.shopId })
          .catch(() => {
            item.finished = true
          })
      }
      item.loading = false
      if (!this.isApp) {
        item.finished = true
      }
      if (res) {
        res = res.data
        if (res.code == 200) {
          /* res.data.data[0].base.user.is_follow = 1;
          res.data.data[0].base.like_list.push({head_img: "https://btw-common-data-oss.betterwestar.com/userProfile/8c7d0258485df3b72d7ce25b9d339509_wh=1920_1920.jpg", tid: 756962,truename: "有种咖啡很甜",unify_id: 5229});
          res.data.data[0].base.like_list.push({head_img: "https://btw-common-data-oss.betterwestar.com/userProfile/8c7d0258485df3b72d7ce25b9d339509_wh=1920_1920.jpg", tid: 756962,truename: "有种咖啡很甜",unify_id: 5229});
           res.data.data[0].base.like_list.push({head_img: "https://btw-common-data-oss.betterwestar.com/userProfile/8c7d0258485df3b72d7ce25b9d339509_wh=1920_1920.jpg", tid: 756962,truename: "有种咖啡很甜",unify_id: 5229});
          res.data.data[0].base.like_info.number = 4
          res.data.data[0].base.comment_info.number = 6 */
          item.page++
          res.data.data
          if (res.data.data && res.data.data.length) {
            if (!this.tabList[curTab].list) {
              this.tabList[curTab].list = res.data.data || []
            } else {
              this.tabList[curTab].list.push(...res.data.data)
            }
          } else {
            if (!this.tabList[curTab].list) {
              this.tabList[curTab].list = res.data.data || []
            }
            item.finished = true
          }
          if (item.needScroll) {
            this.$nextTick(() => {
              const targetScrollTop = item.scrollTop
              setTimeout(() => {
                window.scrollTo(0, targetScrollTop)
              }, 300)
            })
          }
        } else {
          item.finished = true
        }
      }
    },
    handleScroll() {
      // 获取页面滚动距离（兼容所有浏览器）
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.tabList[this.curTab].scrollTop = scrollTop
      //tab曝光埋点
      if (!this.logPush && scrollTop >= this.minPushLogScrollTop) {
        this.logPush = true
        this.$http.get('member/index?a=shareLogPush', {
          from: '门店详情会员动态曝光',
          from_id: 250901
        })
      }
    },
    //初始化tab滚动位置，
    initTabScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      let tabEl = this.$refs.tab
      let tabScrollTop = tabEl.getBoundingClientRect().top + scrollTop
      this.minScrollTop = tabScrollTop - this.appTopBarHeight
      this.minPushLogScrollTop =
        tabEl.getBoundingClientRect().top - window.screen.height
      this.tabList.map((item) => {
        if (!item.scrollTop) {
          item.scrollTop = this.minScrollTop
        }
      })
    },
    bindClickUgcItem(data) {
      if (!this.isApp) {
        return
      }
      let id = data.detail.id
      this.$betterwe.jumpRoute(
        `/ugcDetails?id=${id}&isAutoShowShareMenu=0&tabType=${data.detail.tab_type}`
      )
      this.$http.get('member/index?a=shareLogPush', {
        from: '门店详情会员动态详情点击',
        from_id: 250901
      })
    },
    bindClickLikeList(data) {
      if (!this.isApp) {
        return
      }
      let id = data.detail.id
      this.likeListUgcId = id
      this.showLikeList = true
    },
    bindJumpApp() {
      location.href = 'https://btvue.gymcity.com.cn/app-download'
    },
    bindClickMask(data) {
      let id = data.detail.id
      let url = `/ugcDetails?id=${id}&isAutoShowShareMenu=0&tabType=${data.detail.tab_type}`
      location.href = `https://btvue.gymcity.com.cn/app-download?toAppPath=${encodeURIComponent(
        url
      )}`
    },
    //如果是这个用户id则更新关注状态
    updateUgcFocus(unify_id, isFollow) {
      this.tabList.map((item) => {
        if (item.list) {
          item.list.map((item1) => {
            if (item1.base.user.unify_id == unify_id) {
              item1.base.user.is_follow = isFollow
            }
          })
        }
      })
    },
    //如果点赞则往点赞列表最前面新增一个数据，如果是取消点赞，则根据用户id删除对应的点赞
    updateUgcLove(data, isLike) {
      let user = this.$store.state.userInfo.user
      if (isLike) {
        if (data.base.like_list) {
          data.base.like_list.unshift({
            head_img: user.head_img,
            tid: data.detail.id,
            truename: user.truename,
            unify_id: user.unify_id
          })
        } else {
          data.base.like_list = [
            {
              head_img: user.head_img,
              tid: data.detail.id,
              truename: user.truename,
              unify_id: user.unify_id
            }
          ]
        }
      } else {
        let index = data.base.like_list?.findIndex((item) => {
          return item.unify_id == user.unify_id
        })
        if (index !== undefined) {
          data.base.like_list.splice(index, 1)
        }
      }
    },
    playLikeAnimate() {
      this.showLikeAnimate = true
      setTimeout(() => {
        this.showLikeAnimate = false
      }, 700)
    }
  }
}
</script>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.ugc-container {
  padding-top: 20px;
  width: 100%;
  box-sizing: border-box;

  .tab-container {
    position: sticky;
    z-index: 2;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 20px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;

    .tab-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 16px;
      color: #050b27;
    }

    .tab-list {
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(5, 11, 39, 0.5);

      .tab-item {
        padding: 0px 7px;
        height: 17px;
        font-size: 12px;
      }

      .tab-item-active {
        font-weight: 500;
        color: rgba(5, 11, 39, 1);
      }
    }
  }

  .ugc-list-wrapper {
    position: relative;
    width: 100%;

    .ugc-scroll {
      min-height: 80vh;
      .ugc-list {
        background-color: #f9f9f9;
      }
    }
  }

  ::v-deep .van-popup {
    border-radius: 6px 6px 0px 0px;
  }

  .jump-app-btn-container {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    .jump-app-btn {
      opacity: 0.7;
      padding: 0px 10px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 14px;
      font-weight: bold;
      font-size: 12px;
      color: #050b27;
      border: 1px solid #050b27;
    }
  }

  .empty-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    margin-bottom: 40px;

    .empty-image {
      width: 250px;
    }
  }

  .like-image-animate {
    width: 120px;
    animation: likeAnimate 0.4s ease;
  }
  .like-pop {
    background-color: transparent;
  }
}

@keyframes likeAnimate {
  0% {
    transform: scale(0.2);
  }

  100% {
    transform: scale(1);
  }
}
</style>
